import { makeStyles } from "@material-ui/core";
import { DESKTOP_BREAKPOINT } from "../../consts";

export const useStatsSectionStyles = makeStyles((theme) => ({
  statsWrapper: {
    background: '#FAFAFA',
    padding: "24px 128px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      padding: "24px 32px",
    },
  },

  statsGrid: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "space-between",
    [theme.breakpoints.between("lg", DESKTOP_BREAKPOINT)]: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "20px",
    },
    maxWidth: "1440px",
    margin: "0 auto",
  },

  statCard: {
    display: "flex",
    flexDirection: "column",
    padding: "0 24px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      padding: "0px",
    },
  },

  statDivider: {
    width: "1px",
    backgroundColor: "#e0e0e0",
    alignSelf: "stretch",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "none",
    },
  },

  statIcon: {
    width: "48px",
    height: "48px",
    flexShrink: 0,
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "24px",
      height: "24px",
    },
  },

  statContent: {
    display: "flex",
    gap: 8
  },

  statValue: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#333",
    fontFamily: "'Inter', sans-serif",
    lineHeight: "42px",
    letterSpacing: '-4%',
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "16px",
      lineHeight: "24px",
    },
  },

  statLabel: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#404040",
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif",
    marginTop: "2px",
    letterSpacing: '-4%',
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "12px",
      lineHeight: "16px",
    },
  },
}));
